import React, { useEffect, useRef, useState } from 'react';
import useLocale from '../i18n/useLocale';
import Reveal from './Reveal';

const COUNTERS = (lang) => [
  {
    value: 5,
    suffix: '+',
    label:
      lang === 'de'
        ? 'Jahre Erfahrung'
        : lang === 'tr'
        ? 'Yıl Deneyim'
        : 'Years Experience',
  },
  {
    value: 50,
    suffix: '+',
    label:
      lang === 'de'
        ? 'Live Apps & Sites'
        : lang === 'tr'
        ? 'Yayındaki Uygulama'
        : 'Live Apps & Sites',
  },
  {
    value: 10,
    suffix: '',
    label:
      lang === 'de'
        ? 'Marken-Releases'
        : lang === 'tr'
        ? 'Marka Lansmanı'
        : 'Brand Launches',
  },
  {
    value: 3,
    suffix: '',
    label: lang === 'de' ? 'Sprachen' : lang === 'tr' ? 'Dil' : 'Languages',
  },
];

const Counter = ({ to, suffix }) => {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === 'undefined') {
      setN(to);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !started.current) {
            started.current = true;
            const duration = 1400;
            const startTs = performance.now();
            const tick = (now) => {
              const t = Math.min(1, (now - startTs) / duration);
              const eased = 1 - Math.pow(1 - t, 3);
              setN(Math.round(to * eased));
              if (t < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          }
        });
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [to]);

  return (
    <span ref={ref} className="stat-num">
      {n}
      {suffix}
    </span>
  );
};

const Stats = () => {
  const { lang } = useLocale();
  const items = COUNTERS(lang);

  return (
    <Reveal as="div" className="stats-row">
      {items.map((it, i) => (
        <div className="stat-card" key={i}>
          <Counter to={it.value} suffix={it.suffix} />
          <span className="stat-label">{it.label}</span>
        </div>
      ))}
    </Reveal>
  );
};

export default Stats;
